export default __webpack_public_path__ + "static/media/sticker-B.dfb5ad4a.png";